module.exports = __webpack_public_path__ + "static/media/transactionImage.af1a334e.svg";